import React from 'react';
import { useCallback } from 'react';
const Button = ({
    onClick,
    title,
    disabled = false,
    type = 'button',
    className,
}) => {
    return (
        <button
            className={className}
            onClick={onClick}
            disabled={disabled}
            type={type}
        >
            {title}
        </button>
    );
};
export default Button;
